var showToast = function showToast(_ref, message) {
  var state = _ref.state,
    commit = _ref.commit;
  if (state.toast.show) commit('hideToast');
  setTimeout(function () {
    commit('showToast', {
      color: 'black',
      message: message,
      timeout: 3000
    });
  });
};
var showError = function showError(_ref2, _ref3) {
  var state = _ref2.state,
    commit = _ref2.commit;
  var _ref3$message = _ref3.message,
    message = _ref3$message === void 0 ? 'Failed!' : _ref3$message,
    error = _ref3.error;
  if (state.toast.show) commit('hideToast');
  setTimeout(function () {
    commit('showToast', {
      color: 'error',
      message: message + ' ' + error.message,
      timeout: 10000
    });
  });
};
var showSuccess = function showSuccess(_ref4, message) {
  var state = _ref4.state,
    commit = _ref4.commit;
  if (state.toast.show) commit('hideToast');
  setTimeout(function () {
    commit('showToast', {
      color: 'success',
      message: message,
      timeout: 3000
    });
  });
};
var showLoading = function showLoading(_ref5, value) {
  var state = _ref5.state,
    commit = _ref5.commit;
  commit('setShowLoading', value);
};
var showMessage = function showMessage(_ref6, value) {
  var state = _ref6.state,
    commit = _ref6.commit;
  commit('setShowMessage', value);
};
var toastMessage = function toastMessage(_ref7, value) {
  var state = _ref7.state,
    commit = _ref7.commit;
  commit('setToastMessage', value);
};
var menuSelected = function menuSelected(_ref8, value) {
  var state = _ref8.state,
    commit = _ref8.commit;
  commit('setMenuSelected', value);
};
export default {
  showToast: showToast,
  showError: showError,
  showSuccess: showSuccess,
  showLoading: showLoading,
  showMessage: showMessage,
  toastMessage: toastMessage,
  menuSelected: menuSelected
};